import type { ComponentProps } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PresentingComplaintTab, MedicalHistoryTab, PhysicalAssessmentTab, DiagnosticsTab } from './ClinicalTabs';

interface PatientSessionInformationProps {
  agent: {
    presenting_complaint: ComponentProps<typeof PresentingComplaintTab>['data'];
    medical_history: ComponentProps<typeof MedicalHistoryTab>['data'];
    physical_assessments?: ComponentProps<typeof PhysicalAssessmentTab>['assessments'];
    diagnostic_tests?: ComponentProps<typeof DiagnosticsTab>['tests'];
    physical_assessment_after_consultation?: boolean;
    diagnostic_tests_after_consultation?: boolean;
  };
}

/** Clinical information stays beside the persistent live avatar. */
export function PatientSessionInformation({ agent }: PatientSessionInformationProps) {
  return (
    <section aria-label="Patient information" className="min-w-0 rounded-xl border bg-card p-4 lg:max-h-[65vh] lg:overflow-y-auto">
      <h3 className="mb-4 text-lg font-semibold">Patient information</h3>
      <Tabs defaultValue="presenting">
        <TabsList className="h-auto flex flex-wrap justify-start">
          <TabsTrigger value="presenting">Presenting complaint</TabsTrigger>
          <TabsTrigger value="history">Medical history</TabsTrigger>
          <TabsTrigger value="physical">Physical assessment</TabsTrigger>
          <TabsTrigger value="diagnostics">Diagnostics</TabsTrigger>
        </TabsList>
        <TabsContent value="presenting"><PresentingComplaintTab data={agent.presenting_complaint} /></TabsContent>
        <TabsContent value="history"><MedicalHistoryTab data={agent.medical_history} /></TabsContent>
        <TabsContent value="physical">{agent.physical_assessment_after_consultation ? <p className="p-4 text-sm text-muted-foreground">Physical assessment findings are available after the consultation.</p> : <PhysicalAssessmentTab assessments={agent.physical_assessments} />}</TabsContent>
        <TabsContent value="diagnostics">{agent.diagnostic_tests_after_consultation ? <p className="p-4 text-sm text-muted-foreground">Diagnostic results are available after the consultation.</p> : <DiagnosticsTab tests={agent.diagnostic_tests} />}</TabsContent>
      </Tabs>
    </section>
  );
}
